import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-news_section_linked_articles-click';

/**
 * Click event tracks the quantity of user click to news section third-party articles.
 */
export function trackBrandLeadsNewsSectionLinkedArticlesClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
